var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 42,
    viewBox: "0 0 78 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.4107 15.4078H55.0012V21.8235L60.4107 29.5457V15.4078Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4815 31.6015L47.7935 13.3544H45.6336H41.2821H40.2241V31.6015H45.6336V19.612L53.9677 31.6015H60.4815Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9532 13.3544H33.224H29.994H29.4418L16.7562 31.6015H23.2676L32.2101 18.7385H33.224V24.3465H29.4638L25.8477 29.733H33.224V31.6015H38.6335V13.3544H38.4038H35.9532Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAn);
export default __webpack_public_path__ + "static/media/an.95b38ba2837437ea5df2368327fb1e02.svg";
export { ForwardRef as ReactComponent };